import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';
import { type ResultOf } from '@graphql-typed-document-node/core';

const LocationGql = graphql(`
  query Location($id: Int!) {
    location(id: $id) {
      id
      name
      state {
        abbreviation
      }
    }
  }
`);

export const useLocation = (id: number) => {
  const enabled = !!id;

  const { data, isLoading } = useGraphQLQuery<ResultOf<typeof LocationGql>>({
    operationName: 'Location',
    queryKey: ['location', id],
    query: LocationGql,
    variables: { id },
    enabled,
  });

  return { location: data?.location, isLoading };
};

export default useLocation;
